<template>
  <div>
      <h3>Oops, quiz not found.  No worries, try one of our other quizzes.</h3>
  </div>
</template>

<script>
export default {
  name: 'QuizNotFound',
  props: {
    msg: String
  },
  data () {
      return {

      }
  },
  methods: {
   // will grab the latest quizzes
  },
  create () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
